<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-14 10:02:53
-->
<template>
  <ul class="component--ribbon__nav">
    <li
      v-for="panel in panels"
      :key="panel.name"
      @click="handleTabTitleClicked(panel.name)"
      :class="panel.name === currentTabName ? 'nav-title__active' : null"
    >
      <span>
        {{ panel.label || panel.name }}
      </span>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    panels: {
      type: Array,
    },
    value: {
      type: String,
    },
  },
  data() {
    return {
      currentTabName: this.value,
    };
  },
  methods: {
    handleTabTitleClicked(name) {
      this.currentTabName = name;
      this.$emit("tab-click", name);
    },
  },
  watch: {
    value(newValue, oldValue) {
      this.currentTabName = newValue;
    },
    currentTabName(newValue, oldValue) {
      this.$emit("input", newValue);
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.component--ribbon__nav {
  margin: 0;
  padding: 0;
  font-size: 14px;
  display: flex;
  flex-direction: row;

  li {
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: block;
    cursor: pointer;

    span {
      font-size: 13px;
      padding: 6px 14px 4px 14px;
      border-bottom: 3px solid transparent;
      color: #5d6e7f;
      display: inline-block;
    }

    &.nav-title__active span {
      border-bottom-color: #409eff;
      color: #409eff;
    }
  }
}
</style>